import React from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Box,
  useTheme,
  useMediaQuery
} from '@mui/material';

interface FestojoFormStepperProps {
  steps: string[];
  activeStep: number;
}

const FestojoFormStepper: React.FC<FestojoFormStepperProps> = ({ 
  steps, 
  activeStep 
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box sx={{ width: '100%', mb: 4 }}>
      <Stepper 
        activeStep={activeStep} 
        alternativeLabel={!isMobile}
        orientation={isMobile ? 'vertical' : 'horizontal'}
        sx={{
          '& .MuiStepLabel-root .Mui-completed': {
            color: theme.palette.primary.main,
          },
          '& .MuiStepLabel-root .Mui-active': {
            color: theme.palette.primary.main,
          },
          '& .MuiStepLabel-root .MuiStepLabel-iconContainer .Mui-active': {
            color: theme.palette.primary.main,
          },
          '& .MuiStepConnector-line': {
            borderColor: theme.palette.divider,
          },
          '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main,
          },
          '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': {
            borderColor: theme.palette.primary.main,
          },
        }}
      >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              sx={{
                '& .MuiStepLabel-label': {
                  fontSize: isMobile ? '0.875rem' : '1rem',
                  fontWeight: activeStep === index ? 600 : 400,
                },
                '& .MuiStepLabel-label.Mui-completed': {
                  fontWeight: 500,
                },
                '& .MuiStepLabel-label.Mui-active': {
                  fontWeight: 600,
                  color: theme.palette.primary.main,
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default FestojoFormStepper;

